// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#CDScreen {
	position: absolute;
	top:0px;
	left:0px;
	width: 100vw;
	height: 100vh;
	right: 0px;
	bottom: 0px;
    background-color: rgb(0 0 0 / 38%);
    z-index: 10000;
}

#CDContainer{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 10px;
    min-height: 15vh;
    z-index: 100;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    z-index: 101;
}

#CDData {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	flex: auto;
}

.CDRow, .CDRowTitle {
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
}

.CDRowTitle {
	border-bottom: 1px solid lightgray;
}

.CDTitle{
	flex: 0.50;
	width: 10vw;
}

.CDValue{
	padding: 1vw;
}

.CDInputContainer {
    width: 5vw;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.CDInput{
    font-size: 15px;
    width: 2vw;
    margin-top: 1vh;
    margin-left: 0.5vw;
    margin-right: 0.5vw;
    margin-bottom: 1vh;
	text-align: center;
}

#CDButtons {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding-top: 4vh;
    padding: 0.5vw;
    padding-top: 1vw;
    margin-top: 2vh;
    background-color: lightgray;
}

#CDButtonCancel{
	margin-right: 5vw;
}`, "",{"version":3,"sources":["webpack://./src/project/modules/cellDivision/cellDivision.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,YAAY;CACZ,aAAa;CACb,UAAU;CACV,WAAW;IACR,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;IACzC,YAAY;AAChB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,2BAA2B;CAC3B,uBAAuB;CACvB,UAAU;AACX;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,6BAA6B;CAC7B,mBAAmB;AACpB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;CACrB,kBAAkB;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;CACC,iBAAiB;AAClB","sourcesContent":["#CDScreen {\r\n\tposition: absolute;\r\n\ttop:0px;\r\n\tleft:0px;\r\n\twidth: 100vw;\r\n\theight: 100vh;\r\n\tright: 0px;\r\n\tbottom: 0px;\r\n    background-color: rgb(0 0 0 / 38%);\r\n    z-index: 10000;\r\n}\r\n\r\n#CDContainer{\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    min-height: 15vh;\r\n    z-index: 100;\r\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);\r\n    z-index: 101;\r\n}\r\n\r\n#CDData {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tjustify-content: flex-start;\r\n\talign-items: flex-start;\r\n\tflex: auto;\r\n}\r\n\r\n.CDRow, .CDRowTitle {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: space-around;\r\n\talign-items: center;\r\n}\r\n\r\n.CDRowTitle {\r\n\tborder-bottom: 1px solid lightgray;\r\n}\r\n\r\n.CDTitle{\r\n\tflex: 0.50;\r\n\twidth: 10vw;\r\n}\r\n\r\n.CDValue{\r\n\tpadding: 1vw;\r\n}\r\n\r\n.CDInputContainer {\r\n    width: 5vw;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.CDInput{\r\n    font-size: 15px;\r\n    width: 2vw;\r\n    margin-top: 1vh;\r\n    margin-left: 0.5vw;\r\n    margin-right: 0.5vw;\r\n    margin-bottom: 1vh;\r\n\ttext-align: center;\r\n}\r\n\r\n#CDButtons {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-around;\r\n    align-items: center;\r\n    padding-top: 4vh;\r\n    padding: 0.5vw;\r\n    padding-top: 1vw;\r\n    margin-top: 2vh;\r\n    background-color: lightgray;\r\n}\r\n\r\n#CDButtonCancel{\r\n\tmargin-right: 5vw;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
